<template>
    <div class="page container newsDetail">
        
        <!--Breadcrumbs-->
        <div class="breadcrumbs">
            <router-link to="/" class="">Home</router-link>
            <span class="divider"><ion-icon name="chevron-forward"></ion-icon></span>
            <router-link to="/news" class="">News</router-link>
            <span class="divider"><ion-icon name="chevron-forward"></ion-icon></span>
            <router-link :to="'/news/'+ newsId" class="">{{ newsTitle }}</router-link>
        </div>

        <div v-if="news !== null" class="newsArea">

            <h1>{{ newsTitle }}</h1>
            <p class="date">{{ news.first_publication_date | newsDate }}</p>

            <div class="newsImage image" :style="{backgroundImage: 'url('+ news.data.image.url +')'}"></div>

            <div class="description">
                <div v-for="(desc, index) in news.data.description" :key="'desc_'+index">
                    <p v-if="desc.type === 'paragraph'">
                        {{ desc.text }}
                    </p>
                    <div v-if="desc.type === 'image'" class="imageType">
                        <img :src="desc.url" :alt="desc.alt" />
                    </div>
                    <template>
                        <div v-if="desc.type === 'embed'" class="embedType">
                            <iframe :src="desc.oembed.html | iframeUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </template>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import moment from 'moment'

export default {
    data(){
        return{
            newsId: null,
            news: null,
            newsTitle: null,
            tags: []
        }
    },
    mounted(){

        // Get Event Details
        this.$prismic.client.getByUID('news', this.$route.params.id).then((document) => {
            
            this.newsId = document.uid
            this.news = document
            this.newsTitle = document.data.title
            
            console.log('News details: ', document)
        })
    },
    filters: {
        iframeUrl(value){
            if(value === '') return
            let item = value.replace('<iframe width="480" height="270" src="','').replace('" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>','')
            return item
        },
        newsDate(value){
            return moment(value).local().format('MMM DD, YYYY - h:mm a')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/NewsDetail.vue